var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExploreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.82449 10.4136L13.625 10.4136L13.625 12.3139L9.82449 12.3139L9.82449 10.4136Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92606 12.3138L11.7266 12.3138L11.7266 14.214L7.92606 14.214L7.92606 12.3138Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39481 14.2142L9.19531 14.2142L9.19531 16.7443L5.39481 16.7443L5.39481 14.2142Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80051 12.3138L-5.23163e-07 12.3138L-4.40101e-07 10.4135L3.80051 10.4135L3.80051 12.3138Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69894 14.2142L1.89844 14.2142L1.89844 12.3139L5.69894 12.3139L5.69894 14.2142Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2283 16.7442L4.42773 16.7442L4.42773 14.214L8.2283 14.214L8.2283 16.7442Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92627 16.7442L5.69726 16.7442L5.69727 0.345215L7.92627 0.345215L7.92627 16.7442Z",
    fill: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreIcon);
export default __webpack_public_path__ + "static/media/explore-icon.949af063.svg";
export { ForwardRef as ReactComponent };